import { z } from 'zod';

export const getStyleCatalogsSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    code: z.string(),
  })
);

export type GetStyleCatalogs = z.infer<typeof getStyleCatalogsSchema>;
